angular.module("identifiers")

    .controller("IdentifiersEditCtrl", ['$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$timeout', 'LoginService','$filter', function ($scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $timeout, LoginService, $filter) {                

        $rootScope.title = $filter('translate')('identifiers.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('identifiers.title') }
        ];

        $scope.identifiers = {};

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {            

            $rootScope.breadcrumb = [
                { title: $filter('translate')('grupos.list'), url: "identifiers.list" },
                { title: $filter('translate')('groups.add') }
            ];

        }
        else {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('groups.list'), url: "identifiers.list" },
                { title: $filter('translate')('groups.edit') }
            ];

            Restangular.one('Identifiers', $stateParams.id).get().then(function (results) {
                $scope.identifiers = results;                
            });

        }
                  
        Restangular.all('IdentifiersTypes').getList($scope.options).then(function (identifierTypes) {
            $scope.selectIdentifierTypes = identifierTypes;
            if (identifierTypes.length == 1)
                $scope.identifiers.identifiers_types = identifierTypes[0];
        }, function (response) {
            $scope.errorMessage = response.message;
        });


        $scope.saveIdentifiers = function (frmIdentifier) {
            $scope.identifiers.identifier_type_id = $scope.identifiers.identifiers_types.id;
            if ($scope.identifiers != null && !angular.isUndefined($scope.identifiers.id)) {                                
                $scope.identifiers.put().then(function (result) {
                    if (!angular.isUndefined(result.id)){
                        $state.go("identifiers.list");
                        toastr.success($filter('translate')('identifiers.identifier_modified'));
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {                               
                Restangular.all('Identifiers').post($scope.identifiers).then(function (result) {
                    if (!angular.isUndefined(result.id)){
                        $state.go("identifiers.list");
                        toastr.success($filter('translate')('identifiers.identifier_created'));
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('groups.delete'),
                message: $filter('translate')('identifiers.delete_message') + " " + $scope.identifiers.value + "?",
                onAccept: function () {
                    $scope.identifiers.remove().then(function () {
                        $state.go("identifiers.list");
                        toastr.success("Identidad eliminada");
                    });
                }
            });
        };
        
    }]);